<!-- CrudFechaRango.vue — Rango de fechas compacto para el slot #extra de CrudToolbar -->
<template>
  <div class="rango-fechas">
    <input
      :value="fechaInicio"
      @change="$emit('update:fechaInicio', $event.target.value)"
      type="date"
      class="fecha-input"
      title="Fecha inicio"
    />
    <span class="fecha-sep">–</span>
    <input
      :value="fechaFin"
      @change="$emit('update:fechaFin', $event.target.value)"
      type="date"
      class="fecha-input"
      title="Fecha fin"
    />
    <button
      v-if="fechaInicio || fechaFin"
      class="btn-limpiar-fecha"
      type="button"
      @click="limpiar"
      title="Limpiar fechas"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</template>

<script setup>
defineProps({
  fechaInicio: { type: String, default: "" },
  fechaFin: { type: String, default: "" },
});

const emit = defineEmits(["update:fechaInicio", "update:fechaFin"]);

function limpiar() {
  emit("update:fechaInicio", "");
  emit("update:fechaFin", "");
}
</script>

<style scoped>
.rango-fechas {
  display: flex;
  align-items: center;
  gap: 4px;
}

.fecha-input {
  height: 32px;
  border: 1.5px solid var(--d-border-soft);
  border-radius: var(--d-radius-sm);
  background: var(--d-field-soft);
  color: var(--d-brown);
  padding: 0 8px;
  font-size: 0.75rem;
  font-weight: 600;
  outline: none;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.fecha-input:focus {
  border-color: var(--d-green);
  background: var(--d-field);
}

.fecha-input::-webkit-calendar-picker-indicator {
  opacity: 0.55;
  cursor: pointer;
  filter: invert(30%) sepia(60%) saturate(300%) hue-rotate(60deg);
}

.fecha-sep {
  color: var(--d-text-soft);
  font-size: 0.75rem;
}

.btn-limpiar-fecha {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--d-text-muted);
  font-size: 0.68rem;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-limpiar-fecha:hover {
  background: var(--d-nav-hover-bg);
}

@media (max-width: 480px) {
  .fecha-input {
    min-width: 0;
    flex: 1;
  }
}
</style>
